module.exports = __webpack_public_path__ + "static/media/evidence-prime-logo.35a6275d.svg";